export const environment = {
  production: false,
  apiIp: "https://" + window.location.hostname,
  jiraBasePath: "https://jira.auma.com/projects/",
  guiVersion: "test-2.0.54.140625",

  SENTRY_ORG: "auma-riester-gmbh-co-kg-oi",
  SENTRY_PROJECT: "ris-management-frontend",
  SENTRY_AUTH_TOKEN: "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"
};
